import React from 'react';

const ToolCard = ({ title, description }) => {
  return (
    <div className="tool-card bg-gray-800 p-4 rounded-md shadow-md mb-4">
      <h3 className="text-lg font-semibold mb-2">{title}</h3>
      <p className="text-gray-300">{description}</p>
    </div>
  );
};

export default ToolCard;
